import { WhisperPlayerModal } from '@components/chat/WhisperModal';
import { useChatStore, ChatChannel, useAppStore } from '@stores';
import { IconCircle, IconHumans, IconPlanet } from '@icons';
import { IconPlus, IconX } from '@tabler/icons-react';
import { Glitch } from '@components/helpers/Glitch';
import { useLeaveChannelMutation } from '@http';

interface ChannelSelectorProps {
  channels: ChatChannel[];
}

export function ChannelSelector({ channels }: ChannelSelectorProps) {
  const { mutateAsync } = useLeaveChannelMutation();
  const {
    removeUnreadChannel,
    setActiveChannelId,
    activeChannelId,
    removeChannel,
    unreadChannels,
  } = useChatStore();
  const { id } = useAppStore();

  const buttonClass = (channelId: string) => {
    const channel = channels.find((channel) => channel.id === channelId);

    let base = `sidebar-button chat-${channel?.type}`;

    if (channelId === activeChannelId) {
      base = `${base} ${channel?.type !== 'DIRECT' && 'active'} text-primary`;
    } else {
      base = `${base} text-gray-500`;
    }

    if (unreadChannels.includes(channelId)) {
      base = `${base} border-primary border-b`;
      if (channel?.type === 'DIRECT') {
        base = `${base} border-b-2`;
      }
    }
  
    return base;
  };

  const leaveChannel = () => {
    mutateAsync({ channelId: activeChannelId });

    setActiveChannelId('');
    removeChannel(activeChannelId);
    removeUnreadChannel(activeChannelId);
  };

  const getChannelAvatar = (channel: ChatChannel) => {
    const participant = channel.participants.find((participant) => participant.user.id !== id);
    const avatar = participant?.user.avatar;
    return `img/avatars/${avatar || 'avatar1'}.avif`;
  };

  const isWhisperChannel = channels.some((channel) => channel.type === 'DIRECT' && channel.id === activeChannelId);

  return (
    <div className="sidebar">
      <div className="flex-1 flex flex-col overflow-auto">
        <button onClick={() => setActiveChannelId('')} className={buttonClass('')}>
          <IconHumans className="p-2" />
        </button>

        {channels.map((channel) => (
          <button onClick={() => setActiveChannelId(channel.id)} className={buttonClass(channel.id)} key={channel.id}>
            {channel.type === 'GLOBAL' && <IconPlanet className="p-2" />}
            {channel.type === 'HELP' && <IconCircle className="p-2" />}
            {channel.type === 'DIRECT' && <img src={getChannelAvatar(channel)} />}
          </button>
        ))}
      </div>

      {isWhisperChannel && (
        <button className="sidebar-bottom" onClick={leaveChannel}>
          <IconX size={20} />
        </button>
      )}

      <WhisperPlayerModal className="whisper">
        <button className="sidebar-bottom">
          <Glitch><IconPlus size={20} /></Glitch>
        </button>
      </WhisperPlayerModal>
    </div>
  );
}